import { useRef } from 'react';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
export const useSpzaInstrumentService = ()=>{
    const refInstrument = useRef(SpzaInstrumentService.getProvider());
    return [
        refInstrument.current
    ];
};
